import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "miolo.sidebar.collapsed"

export default class extends Controller {
  static targets = ["desktopToggle", "headerToggle", "desktopIcon"]

  connect() {
    this.applyState(this.collapsed)
  }

  toggle() {
    this.collapsed = !this.collapsed
    this.applyState(this.collapsed)
  }

  applyState(collapsed) {
    document.documentElement.classList.toggle("sidebar-collapsed", collapsed)

    const toggleButtons = [...this.desktopToggleTargets, ...this.headerToggleTargets]
    toggleButtons.forEach((button) => {
      button.setAttribute("aria-expanded", String(!collapsed))
    })

    if (this.hasDesktopIconTarget) {
      this.desktopIconTarget.textContent = collapsed ? "»" : "«"
    }

    if (this.hasDesktopToggleTarget) {
      this.desktopToggleTarget.title = collapsed ? "Expandir menu" : "Recolher menu"
      this.desktopToggleTarget.setAttribute("aria-label", collapsed ? "Expandir menu lateral" : "Recolher menu lateral")
    }
  }

  get collapsed() {
    return localStorage.getItem(STORAGE_KEY) === "1"
  }

  set collapsed(value) {
    localStorage.setItem(STORAGE_KEY, value ? "1" : "0")
  }
}